import React, { createContext, useMemo, useState, useContext } from "react";
import { createTheme, ThemeProvider, CssBaseline } from "@mui/material";

const ThemeContext = createContext();
export const useThemeMode = () => useContext(ThemeContext);

const ThemeContextProvider = ({ children }) => {
  const [mode, setMode] = useState("light");

  const toggleTheme = () => {
    setMode((prev) => (prev === "light" ? "dark" : "light"));
  };

  const theme = useMemo(() =>
    createTheme({
      palette: {
        mode,
        background: {
          default: mode === 'dark' ? '#121212' : '#f4f6f8',
          paper: mode === 'dark' ? '#1e1e1e' : '#ffffff',
        },
        primary: {
          // main: mode === 'dark' ? '#121212' : '#f4f6f8',
          main:'#17242c',
        },
        secondary: {
          main: '#9c27b0',
        },
      },
      shape: {
        borderRadius: 2,
      },
     typography: {
      fontFamily: `'Titillium Web', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
      fontSize: 13,
      fontWeightLight: 200,
      fontWeightRegular: 300,
      fontWeightMedium: 400,
      h1: { fontSize: '2rem', fontWeight: 400 },
      h2: { fontSize: '1.6rem', fontWeight: 400 },
      h3: { fontSize: '1.4rem', fontWeight: 400 },
      h4: { fontSize: '1.2rem', fontWeight: 400 },
      h7: { fontSize: '1rem', fontWeight: 400 },
      body1: { fontSize: '0.9rem', fontWeight: 400 },
      body2: { fontSize: '0.8rem', fontWeight: 400 },
    },

      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: 'none',
              borderRadius: 2,
              fontWeight: 500,
              paddingInline: 16,
              minHeight: 36,
            },
          },
        },
        MuiChip: {
            styleOverrides: {
              root: {
                borderRadius: 4, // or 0 if you want sharp corners
                fontWeight: 500,
                fontSize: '0.65rem', // optional: tighter font
                height: 24,          // optional: slim height
                paddingInline: 2,    // optional: adjust padding
              },
              label: {
                paddingInline: 8,   // optional: better spacing
              },
            },
        },
        MuiTabs: {
            styleOverrides: {
              indicator: {
                backgroundColor: 'currentColor',
              },
            },
          },
          MuiTab: {
            styleOverrides: {
              root: ({ theme }) => ({
                textTransform: 'none',
                color: theme.palette.mode === 'dark' ? '#aaa' : '#555',
                '&.Mui-selected': {
                  color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main,
                },
              }),
            },
          },
          MuiSwitch: {
          styleOverrides: {
            switchBase: {
              // base knob color when checked
              '&.Mui-checked': {
                color: '#90caf9', // light blue or any bright color
              },
              '&.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#90caf9',
              },
            },
            track: ({ theme }) => ({
              backgroundColor: theme.palette.mode === 'dark' ? '#555' : '#ccc',
            }),
          },
        },


      },
    }), [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
